import React from 'react'
import HomeSevenScreen from './HomeSevenScreen'

export default () => {
    //Use HomeContainer component for a regular application and HomeSevenScreen component for a
    //seven screen application
    return (
        <>
            {/* <HomeContainer /> */}
            <HomeSevenScreen />
        </>
    )
}
